import { render } from "./RegistrationStepsComponent.vue?vue&type=template&id=965d83ae&scoped=true"
import script from "./RegistrationStepsComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationStepsComponent.vue?vue&type=script&lang=js"

import "./RegistrationStepsComponent.vue?vue&type=style&index=0&id=965d83ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965d83ae"]])

export default __exports__